import Image from 'next/image'
import { useState } from 'react'

import { useIntl } from 'react-intl'
import { LuCirclePlus, LuTruck } from 'react-icons/lu'

import { Button } from '@/lib/core/components/Button'
import { routePaths } from '@/lib/core/constants/routes'

import { AddAssetModal } from '@/lib/features/Assets/components/AddAssetModal'
import { StatsBox } from '@/lib/features/Dashboard/components/StatsBox'
import {
  Header,
  Title,
  Wrapper,
} from '@/lib/features/Dashboard/components/SummaryCard/SummaryCard.styles'
import messages from '@/lib/features/Dashboard/Dashboard.messages'
import { Details, Row, Summary } from '@/lib/features/Dashboard/Dashboard.styles'

import { FeatureTypes } from '@/lib/utils/features'

import { AssetsRowProps } from './Rows.types'

export const AssetsRow = ({ onUpdate, dashboardData, isLoading }: AssetsRowProps) => {
  const { formatMessage } = useIntl()
  const [addAssetModalOpen, setAddAssetModalOpen] = useState(false)
  const { assets } = messages

  return (
    <>
      <AddAssetModal
        isActive={addAssetModalOpen}
        onClose={(withSuccess) => {
          setAddAssetModalOpen(false)

          if (withSuccess) {
            onUpdate()
          }
        }}
      />
      <Row>
        <Summary>
          <Wrapper $color={FeatureTypes.ASSETS}>
            <Header>
              <LuTruck size="56" strokeWidth={1.5} />
              <Title>{formatMessage(assets.allAssets)}</Title>
            </Header>
            <Button
              type="button"
              $fitToContent
              lightVariant
              variant="ghost"
              size="large"
              style={{ visibility: 'hidden' }}
              onClick={() => setAddAssetModalOpen(true)}
              leftIcon={<LuCirclePlus size="24" strokeWidth={1} />}
            >
              {formatMessage(messages.addNew)}
            </Button>
          </Wrapper>
        </Summary>
        <Details>
          <StatsBox
            href={routePaths.assetsAll}
            color={FeatureTypes.ASSETS}
            counter={dashboardData?.assets.all ?? 0}
            image={
              <Image
                src="/images/dashboard/assets/assets-all.svg"
                alt="Assets"
                width={180}
                height={100}
              />
            }
            isLoading={isLoading}
            label={formatMessage(assets.allAssets)}
          />
          <StatsBox
            href={routePaths.assetsMyVehicles}
            color={FeatureTypes.ASSETS}
            counter={dashboardData?.assets.myVehicles ?? 0}
            image={
              <Image
                src="/images/dashboard/assets/assets-my-vehicles.svg"
                alt="Assets"
                width={180}
                height={100}
              />
            }
            isLoading={isLoading}
            label={formatMessage(assets.myVehicles)}
          />
          <StatsBox
            href={routePaths.assetsMyVehicles}
            color={FeatureTypes.ASSETS}
            counter={dashboardData?.assets.myPtus ?? 0}
            image={
              <Image
                src="/images/dashboard/assets/assets-my-ptu.svg"
                alt="Assets"
                width={180}
                height={100}
              />
            }
            isLoading={isLoading}
            label={formatMessage(assets.myPtus)}
          />
          <StatsBox
            href={routePaths.assetsShared}
            color={FeatureTypes.ASSETS}
            counter={dashboardData?.assets.vehiclesSharedWithMe ?? 0}
            image={
              <Image
                src="/images/dashboard/assets/assets-vehicle-shared.svg"
                alt="Assets"
                width={180}
                height={100}
              />
            }
            isLoading={isLoading}
            label={formatMessage(assets.vehiclesSharedWithMe)}
          />
          <StatsBox
            href={routePaths.assetsShared}
            color={FeatureTypes.ASSETS}
            counter={dashboardData?.assets.ptusSharedWithMe ?? 0}
            image={
              <Image
                src="/images/dashboard/assets/assets-ptu-shared.svg"
                alt="Assets"
                width={180}
                height={100}
              />
            }
            isLoading={isLoading}
            label={formatMessage(assets.ptusSharedWithMe)}
          />
        </Details>
      </Row>
    </>
  )
}
